const FormConstants = {
    SignUpFormId: '24a135e1-7683-4dc9-89ab-87e7e3c158d4',
    LongListFormId: '9d13962b-2de4-47ce-9c84-b22372a4fb67'
}

export default FormConstants;